module.exports = __webpack_public_path__ + "static/media/market-challenger.a73d4958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/market-challenger.jpg
// module id = 2628
// module chunks = 0